import styled from 'styled-components';
import { ControlButtons } from '../index.styled';
import { theme } from 'types';

export const FormStyled = styled.div<theme.TGridJustifyAlign>`
    ${({ theme }) => theme.mixins.gridJustifyAlign};
    width: 100%;
    grid-auto-columns: 100%;
    min-width: 500px;
`;

export const FormFields = styled.div<theme.TGridJustifyAlign>`
    ${({ theme }) => theme.mixins.gridJustifyAlign};
    gap: 1rem;
    grid-auto-columns: 100%;
    width: 100%;
`;
export const FormControlButtons = styled(ControlButtons)`
    padding: 1rem 0 0;
    gap: 1rem;
`;
